<template>
  <a-input
    :value="props.value"
    :maxlength="18"
    @update:value="handleChange"
  />
</template>

<script lang="ts" setup name="input-mobile">
import { idCardInputProps } from './props'

const props = defineProps(idCardInputProps)
type EmitEvents = {
  (e:'update:value', value:string):void
}
const emits = defineEmits<EmitEvents>()

function handleChange(value) {
  const v = value.replace(/[^0-9xX]/gi, '')
  emits('update:value', v)
}
</script>
